<template>
    <div class="h-screen flex justify-center items-center login-background">
        <div class="w-full max-w-sm px-2">

            <div class="logo mb-10">
                <img src="@/assets/logo.svg" />
            </div>

            <form class="px-8 pt-6 pb-8 mb-4"
            @submit="realizarRecovery">

                <div v-if="mensajeError != ''" class="bg-red text-white px-4 py-2 mb-4">
                    <strong>Ha ocurrido un error.</strong>
                    <span class="block sm:inline">{{ mensajeError }}</span>
                </div>

                <div v-if="mensajeExito != ''" class="bg-greenlight text-white px-4 py-2 mb-4">
                    <strong>Excelente.</strong>
                    <span class="block sm:inline">{{ mensajeExito }}</span>
                </div>


                <div class="text-azuloscuro text-2xl text-center leading-7 mb-10 font-semibold">
                    Introduce tu nueva contraseña
                </div>


                <div class="mb-6">
                    <label class="block text-azulfondoclaro text-sm mb-2" for="password">
                        Contraseña
                    </label>
                    <input class="appearance-none bg-transparent border-b-2 w-full pb-2 text-azuloscuro mb-3 leading-tight"
                    type="password" placeholder="" v-model="password">
                </div>

                <div class="mb-6">
                    <label class="block text-azulfondoclaro text-sm mb-2" for="password">
                        Repite Contraseña
                    </label>
                    <input class="appearance-none bg-transparent border-b-2 w-full pb-2 text-azuloscuro mb-3 leading-tight"
                    type="password" placeholder="" v-model="confirmar_password">
                </div>


                <div class="flex justify-between mt-20">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                    type="submit" :class="{ 'hidden': datosCargados == false }">
                        Guardar
                    </button>

                    <button class="bg-gray-600 mr-2 text-sm font-semibold text-white py-2 px-4 rounded-full w-full"
                    type="button" :class="{ 'hidden': datosCargados == true }">
                        Enviando datos...
                    </button>
                </div>


            </form>
        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'

    const RecoveryNewPass = {
        name: 'RecoveryNewPass',
        layout: '',
        data: function(){
            return {
                datosCargados: true,
                mensajeExito: '',
                mensajeError: '',

                password: '',
                confirmar_password: '',
            }
        },
        methods: {
            realizarRecovery(e){
                e.preventDefault();

                this.datosCargados = false
                this.mensajeExito = ''
                this.mensajeError = ''

                if( this.password != '' &&
                    this.confirmar_password != '' ){

                    sessionStorage.setItem("login_message", 'pass_changed')
                    this.$router.push({name:'login'})

                    this.datosCargados = true
                }
                else{
                    this.datosCargados = true
                    this.mensajeError = "Debe llenar correctamente todos los campos para poder ingresar al sistema"
                }
            }
        }
    }

    export default RecoveryNewPass;
</script>

<style>
    @import '../assets/styles/style_login.css';
</style>
